import React, { useState, useEffect } from 'react';
import {
    Button,
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    FormControlLabel,
    Checkbox,
    CircularProgress,
    Box,
} from '@mui/material';
import KeyboardDoubleArrowDownOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowDownOutlined';
import BackupTableOutlinedIcon from '@mui/icons-material/BackupTableOutlined';
import { RIX_ENGINE_COMPANIES_FIELDS, fetchRixEngineCompanies } from '../../../API/RixEngineReport';
import { toast } from 'react-toastify';

function CompaniesOptionsForm({ onGenerate }) {
    const [options, setOptions] = useState({
        fields: RIX_ENGINE_COMPANIES_FIELDS.map((f) => f.key),
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const stored = localStorage.getItem('RixEngineCompaniesOptions');
        if (stored) {
            try {
                const parsed = JSON.parse(stored);
                if (Array.isArray(parsed.fields) && parsed.fields.length > 0) {
                    setOptions({ fields: parsed.fields });
                }
            } catch (_) {}
        }
    }, []);

    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        let fields = [...options.fields];
        if (checked) {
            if (!fields.includes(name)) fields.push(name);
        } else {
            fields = fields.filter((f) => f !== name);
        }
        setOptions({ ...options, fields });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            setLoading(true);
            const fieldsToSend = options.fields.length > 0 ? options.fields : null;
            const list = await fetchRixEngineCompanies({
                fields: fieldsToSend === null ? undefined : fieldsToSend,
            });
            localStorage.setItem('RixEngineCompaniesOptions', JSON.stringify({ fields: options.fields }));
            onGenerate(Array.isArray(list) ? list : [], options.fields);
        } catch (err) {
            toast.error('Failed to load report.');
            onGenerate([], options.fields);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Grid container spacing={2} sx={{ width: '100%', marginLeft: '0px' }}>
            <Accordion sx={{ width: '100%' }}>
                <AccordionSummary
                    expandIcon={<KeyboardDoubleArrowDownOutlinedIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    sx={{ backgroundColor: '#f0f3f5', width: '100%' }}
                >
                    Options
                </AccordionSummary>
                <AccordionDetails sx={{ width: '100%' }}>
                    <form onSubmit={handleSubmit}>
                        <Grid item xs={12} md={12} sx={{ width: '100%', margin: '25px 0 25px auto' }}>
                            <Grid item xs={12} md={12}>
                                <strong>Report fields</strong>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                {RIX_ENGINE_COMPANIES_FIELDS.map((field) => (
                                    <FormControlLabel
                                        key={field.key}
                                        control={
                                            <Checkbox
                                                checked={options.fields.includes(field.key)}
                                                onChange={handleCheckboxChange}
                                                name={field.key}
                                            />
                                        }
                                        label={field.label}
                                    />
                                ))}
                            </Grid>
                        </Grid>
                    </form>
                </AccordionDetails>
            </Accordion>
            <Grid item xs={12} md={12}>
                <Button
                    size="large"
                    startIcon={<BackupTableOutlinedIcon fontSize="small" />}
                    onClick={handleSubmit}
                    type="button"
                    variant="contained"
                    color="primary"
                    sx={{ marginLeft: '-15px' }}
                    disabled={loading}
                >
                    Generate report
                </Button>
            </Grid>
            {loading && (
                <Grid item xs={12} md={12}>
                    <Box justifyContent="center" textAlign="center" alignItems="center" py={2}>
                        <CircularProgress size={40} />
                    </Box>
                </Grid>
            )}
        </Grid>
    );
}

export default CompaniesOptionsForm;
